<template>
  <v-container>
    <calendar/>
  </v-container>
</template>

<script>
import Calendar from "../components/Calendar";

export default {
  components: {
    Calendar
  }
};
</script>

<style lang="scss">
@import "~@fullcalendar/core/main.css";
@import "~@fullcalendar/daygrid/main.css";
</style>
